export interface PlantItem {
  id: string;
  name: string;
  scientific_name: string;
  category: "Indoor" | "Outdoor" | "Flowering" | "Trees" | "Succulents" | "Herbs" | "Medicinal";
  difficulty: "Easy" | "Moderate" | "Advanced";
  watering: "Low" | "Medium" | "High";
  sunlight: "Low Light" | "Medium Light" | "Bright Indirect" | "Full Sun";
  image: string;
  pet_safety: "Pet Friendly" | "Not Pet Friendly";
  description: string;
  benefits: string[];
}

export const BASE_PLANTS: PlantItem[] = [];

export const GENERATED_PLANTS: PlantItem[] = [];
